import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { UiModule } from 'src/app/shared/ui/ui.module';
import { DiscussionBoardComponent } from './discussion-board.component';

@NgModule({
  declarations: [DiscussionBoardComponent],
  imports: [CommonModule, FormsModule, TranslateModule, UiModule],
  exports: [DiscussionBoardComponent]
})
export class DiscussionBoardModule { }
